// Importing necessary hooks and components from React and Material-UI libraries
import { useState } from "react";
import { Button, Grid, Typography, Tooltip } from "@mui/material";
// Importing a utility function to check if a value is a known date or a string
import { checkKnownDateOrString, LoadingButtonText } from "../../../common";
// Importing modal components for editing and adding items to the sample request
import {
  ResubmitEditSampleRequestDetailsModal,
  ResubmitAddItemSampleRequestModal,
} from "./";
// Importing a context hook for managing the state of the resubmit request
import { useResubmitRequestContext } from "./";
// Importing lodash for utility functions
import _ from "lodash";

export function ResubmitSampleRequestDetails({ handleSubmit, isSubmitting }) {
  // State hooks for controlling the visibility of the edit and add item modals
  const [openEditRequestModal, setOpenEditRequestModal] = useState(false);
  const handleOpenEditRequestModal = () => setOpenEditRequestModal(true);
  const [openAddItemModal, setOpenAddItemModal] = useState(false);
  const handleOpenAddItemModal = () => setOpenAddItemModal(true);
  const { state } = useResubmitRequestContext();
  let newData = _.omit(state.sampleRequestDetails, ["items"]);

  return (
    <Grid item>
      <div className="card">
        <div className="card__text" {...TextDivProps}>
          <Grid item xs={12}>
            {/* Displaying the title of the resubmit request section */}
            <Typography>
              <b>Resubmit Request </b>
            </Typography>
          </Grid>
          <Grid item xs={12} mb={6}>
            {/* Instructions for editing or deleting items in the sample request */}
            <Typography component="h1" variant="h6" align="center">
              The list of items in the sample request is given below. Click on
              the items in the list to edit or delete the item
            </Typography>
          </Grid>
          {/* Mapping over the keys of the newData object to display each item's details */}
          <Grid container>
            {Object.keys(newData).map((oneKey, i) => {
              return (
                <Grid item xs={12} sm={6} md={4} lg={2} key={i}>
                  <Grid item>
                    <Typography variant="h6">
                      {_.startCase(Object.keys(newData)[i]) + ":"}
                    </Typography>
                  </Grid>

                  <Grid item>
                    <Typography
                      variant="h6"
                      sx={{
                        mb: 1.5,
                        color: "black",
                      }}
                    >
                      {checkKnownDateOrString(oneKey, newData[oneKey])}
                    </Typography>
                  </Grid>
                </Grid>
              );
            })}
          </Grid>
          {/* Buttons for editing details and submitting the request */}
          <Grid {...ButtonGridProps}>
            <Grid item xs={12} sm={4} md={2.5} lg={1.5}>
              <Button {...EditButtonProps} onClick={handleOpenEditRequestModal}>
                Edit Details
              </Button>
            </Grid>
            <Grid item xs={12} sm={4} md={2.5} lg={1.5}>
              <Tooltip
                title={
                  state?.sampleRequestDetails?.items?.length < 1 ? (
                    <p style={{ fontSize: "13px" }}>
                      Minimum 1 item required for submission
                    </p>
                  ) : (
                    ""
                  )
                }
                placement="top"
                arrow
              >
                <div>
                  <Button
                    disabled={
                      isSubmitting ||
                      state?.sampleRequestDetails?.items?.length < 1
                        ? true
                        : false
                    }
                    {...SubmitButtonProps}
                    onClick={handleSubmit}
                  >
                    <LoadingButtonText loading={isSubmitting} text="Submit" />
                  </Button>
                </div>
              </Tooltip>
            </Grid>
          </Grid>
        </div>
      </div>
      {/* Modal for editing the sample request details */}
      <ResubmitEditSampleRequestDetailsModal
        open={openEditRequestModal}
        setOpen={setOpenEditRequestModal}
        handleOpen={handleOpenEditRequestModal}
      />
      {/* Modal for adding an item to the sample request */}
      <ResubmitAddItemSampleRequestModal
        open={openAddItemModal}
        setOpen={setOpenAddItemModal}
        handleOpen={handleOpenAddItemModal}
      />
    </Grid>
  );
}

const TextDivProps = {
  style: {
    padding: "20px 20px",
    overflowWrap: "break-word",
  },
};
const ButtonGridProps = {
  container: true,
  justifyContent: "center",
  columnSpacing: 2,
  rowSpacing: 2,
};
const EditButtonProps = {
  float: "right",
  size: "small",
  variant: "contained",
  sx: {
    width: "100%",
    fontSize: "14px",
    textTransform: "capitalize",
  },
};
const SubmitButtonProps = {
  float: "left",
  size: "small",
  variant: "contained",
  sx: {
    width: "100%",
    fontSize: "14px",
    backgroundColor: "#bc9b6a",
    "&:hover": {
      backgroundColor: "#a6885b",
    },
    textTransform: "capitalize",
  },
};
